export const newTrackTemplate = {
  sampleName: 'No sample',
  sampleUrl: '',
  samplePath: '',
  bankPath: '',
  bankName: '',
  trackVolume: -6,
  trackPanning: 0,
  isMuted: false,
};

export const rowMaxLength = 32;

export const buttonStyle = {
  border:'1.7px solid #d81a60',
  fontSize: '20px',
  fontWeight: 'bold',

};

export const lightBg = 'rgb(231 60 123 / 20%)';

export const darkBg = 'rgb(179 20 78 / 40%)';

export const buttonText = 'NEW TRACK';